// Utilitaires fuseau Europe/Paris (gère l'heure d'été/hiver via Intl)

const PARIS = 'Europe/Paris';

// Décalage (minutes) de Paris par rapport à UTC pour un instant donné
function parisOffsetMinutes(date) {
  const paris = new Date(date.toLocaleString('en-US', { timeZone: PARIS }));
  const utc = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  return Math.round((paris - utc) / 60000);
}

// ISO UTC -> { date:'YYYY-MM-DD', time:'HH:mm' } en heure de Paris
export function isoToParisParts(iso) {
  const d = new Date(iso);
  const s = d.toLocaleString('sv-SE', { timeZone: PARIS }); // 'YYYY-MM-DD HH:mm:ss'
  return { date: s.slice(0, 10), time: s.slice(11, 16) };
}

// 'YYYY-MM-DD','HH:mm' (heure de Paris) -> ISO UTC
export function parisPartsToIso(dateStr, timeStr) {
  const assumedUtc = new Date(`${dateStr}T${timeStr}:00Z`);
  const offset = parisOffsetMinutes(assumedUtc);
  return new Date(assumedUtc.getTime() - offset * 60000).toISOString();
}

// Affichage lisible d'une plage en heure de Paris
export function formatParisRange(startIso, endIso) {
  const s = new Date(startIso);
  const e = new Date(endIso);
  const day = s.toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: 'long', timeZone: PARIS });
  const t1 = s.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: PARIS });
  const t2 = e.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: PARIS });
  return `${day} · ${t1} – ${t2}`;
}

export function formatParisTime(iso) {
  return new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: PARIS });
}

// Ajoute des minutes à un ISO et renvoie un ISO
export function addMinutesIso(iso, minutes) {
  return new Date(new Date(iso).getTime() + minutes * 60000).toISOString();
}

// Durée en minutes entre deux ISO
export function durationMinutes(startIso, endIso) {
  return Math.round((new Date(endIso) - new Date(startIso)) / 60000);
}
